/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import TimeAndEffortIcon from 'icons/TimeAndEffortIcon';

const messages = defineMessages({
  title: {id: 'navigation.reports.time-and-effort'},
});

const TimeAndEffortItem = () => (
  <RouteLinkItem
    iconBefore={TimeAndEffortIcon}
    route="midas/reports/time-and-effort"
    title={messages.title}
  />
);

export default TimeAndEffortItem;
